import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Evento } from '../models/evento.model';
import { catchError, map } from 'rxjs';
import { handleError } from '@/app/core';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class EventoService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'evento/';

  create(evento: Partial<Evento>) {
    return this.http.post<CustomResponse<Evento>>(this.url, evento).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  findAll(params: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Evento[], HasPagination>>>(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  remove(id: number) {
    const dir = this.url + id;
    return this.http.delete(dir).pipe(catchError((err) => handleError(err)));
  }
}
